import React from 'react';
import { motion } from 'framer-motion';
const companies = [{
  name: 'Nationwide',
  color: '#0047BB'
}, {
  name: 'Pacific Life',
  color: '#003B71'
}, {
  name: 'Lincoln Financial',
  color: '#00594C'
}, {
  name: 'Transamerica',
  color: '#003DA5'
}, {
  name: 'Prudential',
  color: '#005EB8'
}, {
  name: 'Allianz',
  color: '#003781'
}];
export function TrustLogos() {
  return <section className="py-10 bg-white border-y border-gray-100" data-id="element-130">
      <div className="max-w-6xl mx-auto px-6" data-id="element-131">
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm text-gray-400 font-medium uppercase tracking-widest mb-8" data-id="element-132">
          Respaldados por las aseguradoras más confiables
        </motion.p>
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14" data-id="element-133">
          {companies.map((company, index) => <motion.div key={company.name} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center gap-2 opacity-60 hover:opacity-100 transition-opacity duration-300" data-id="element-134">
              <div className="w-3 h-3 rounded-full flex-shrink-0" style={{
            backgroundColor: company.color
          }} data-id="element-135" />
              <span className="text-lg md:text-xl font-bold tracking-tight whitespace-nowrap" style={{
            color: company.color
          }} data-id="element-136">
                {company.name}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}